/* Rapor galerisi + kategori filtresi.

   Kart tıklanınca rapor tam ekran açılır. Aynı gruptaki (kategorideki)
   raporlar arasında oklarla, klavyeyle ve dokunmatik kaydırmayla gezilir.
   Görsele tıklanınca yakınlaştırılır; yakınken sürükleyerek gezinilir. */
(function () {
  'use strict';

  var ZOOM = 2.4;

  class KsLightbox extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('[data-lightbox]');
      this.img = this.querySelector('[data-lightbox-img]');
      this.stage = this.querySelector('[data-lightbox-stage]');
      this.caption = this.querySelector('[data-lightbox-caption]');
      this.metaEl = this.querySelector('[data-lightbox-meta]');
      this.posEl = this.querySelector('[data-lightbox-pos]');
      this.zoomBtn = this.querySelector('[data-lightbox-zoom]');
      this.prevBtn = this.querySelector('[data-lightbox-prev]');
      this.nextBtn = this.querySelector('[data-lightbox-next]');
      this.empty = this.querySelector('[data-lab-empty]');

      this.triggers = Array.from(this.querySelectorAll('[data-lightbox-open]'));
      this.group = [];
      this.index = 0;
      this.zoomed = false;
      this.release = null;

      this.addEventListener('click', (event) => {
        const open = event.target.closest('[data-lightbox-open]');
        if (open) { this.open(open); return; }
        if (event.target.closest('[data-lightbox-close]')) { this.close(); return; }
        if (event.target.closest('[data-lightbox-prev]')) { this.step(-1); return; }
        if (event.target.closest('[data-lightbox-next]')) { this.step(1); return; }
        if (event.target.closest('[data-lightbox-zoom]')) { this.toggleZoom(); return; }
        if (event.target === this.img) { this.toggleZoom(); return; }
        // Görselin dışına tıklayınca kapansın.
        if (event.target === this.box || event.target === this.stage) this.close();
      });

      document.addEventListener('keydown', (event) => {
        if (!this.box || this.box.hidden) return;
        if (event.key === 'Escape') { this.close(); return; }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
      });

      this.bindPan();
      this.bindFilter();
    }

    /* ---- kategori filtresi ---- */
    bindFilter() {
      this.querySelectorAll('[data-lab-cat]').forEach((button) => {
        button.addEventListener('click', () => {
          const cat = button.dataset.labCat;
          this.querySelectorAll('[data-lab-cat]').forEach((b) => {
            const on = b === button;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', String(on));
          });
          // Raporlar kategori gruplarına ayrıldı; filtre grubun tamamını gizler.
          let visible = 0;
          this.querySelectorAll('[data-lab-group]').forEach((group) => {
            const show = !cat || group.dataset.cat === cat;
            group.hidden = !show;
            if (show) visible += 1;
          });
          if (this.empty) this.empty.hidden = visible > 0;
        });
      });
    }

    /* ---- galeri ---- */
    open(trigger) {
      if (!this.box) return;
      this.trigger = trigger;

      // Aynı gruptaki görünür raporlar galeriyi oluşturur.
      const g = trigger.dataset.group || '';
      this.group = this.triggers.filter((t) => (t.dataset.group || '') === g && t.offsetParent !== null);
      if (!this.group.length) this.group = [trigger];
      this.index = Math.max(0, this.group.indexOf(trigger));

      this.render();
      this.box.hidden = false;
      window.requestAnimationFrame(() => this.box.classList.add('is-open'));
      window.KS.lockScroll(true);
      this.release = window.KS.trapFocus(this.box, this.querySelector('[data-lightbox-close]'));
    }

    render() {
      const t = this.group[this.index];
      if (!t) return;
      this.resetZoom();
      this.img.src = t.dataset.src;
      this.img.alt = t.dataset.caption || '';
      if (this.caption) this.caption.textContent = t.dataset.caption || '';
      if (this.metaEl) this.metaEl.textContent = t.dataset.meta || '';

      const many = this.group.length > 1;
      if (this.posEl) this.posEl.textContent = many ? (this.index + 1) + ' / ' + this.group.length : '';
      if (this.prevBtn) this.prevBtn.hidden = !many;
      if (this.nextBtn) this.nextBtn.hidden = !many;
    }

    step(delta) {
      if (this.group.length < 2) return;
      this.index = (this.index + delta + this.group.length) % this.group.length;
      this.render();
    }

    /* ---- yakınlaştırma ---- */
    toggleZoom() {
      this.zoomed ? this.resetZoom() : this.applyZoom();
    }

    applyZoom() {
      this.zoomed = true;
      this.pan = { x: 0, y: 0 };
      this.img.style.transform = 'scale(' + ZOOM + ')';
      this.img.classList.add('is-zoomed');
      if (this.zoomBtn) this.zoomBtn.setAttribute('aria-pressed', 'true');
    }

    resetZoom() {
      this.zoomed = false;
      this.pan = { x: 0, y: 0 };
      this.img.style.transform = '';
      this.img.classList.remove('is-zoomed');
      if (this.zoomBtn) this.zoomBtn.setAttribute('aria-pressed', 'false');
    }

    /* Yakınken sürükleyerek gezinme; uzakken yatay kaydırma sayfa değiştirir. */
    bindPan() {
      let sx = 0, sy = 0, px = 0, py = 0, dragging = false;
      const start = (x, y) => { dragging = true; sx = x; sy = y; px = this.pan ? this.pan.x : 0; py = this.pan ? this.pan.y : 0; };
      const move = (x, y) => {
        if (!dragging || !this.zoomed) return;
        this.pan = { x: px + (x - sx), y: py + (y - sy) };
        this.img.style.transform = 'scale(' + ZOOM + ') translate(' + (this.pan.x / ZOOM) + 'px, ' + (this.pan.y / ZOOM) + 'px)';
      };
      const end = (x) => {
        if (!dragging) return;
        dragging = false;
        if (!this.zoomed && Math.abs(x - sx) > 60) this.step(x < sx ? 1 : -1);
      };

      this.img.addEventListener('pointerdown', (e) => { start(e.clientX, e.clientY); this.img.setPointerCapture(e.pointerId); });
      this.img.addEventListener('pointermove', (e) => { if (dragging && this.zoomed) e.preventDefault(); move(e.clientX, e.clientY); });
      this.img.addEventListener('pointerup', (e) => end(e.clientX));
      this.img.addEventListener('pointercancel', () => { dragging = false; });
      this.img.addEventListener('dragstart', (e) => e.preventDefault());
    }

    close() {
      if (!this.box || this.box.hidden) return;
      this.box.classList.remove('is-open');
      if (this.release) { this.release(); this.release = null; }
      window.KS.lockScroll(false);
      window.setTimeout(() => {
        this.box.hidden = true;
        this.img.src = '';
        this.resetZoom();
      }, 260);
      if (this.trigger) this.trigger.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('ks-lightbox')) customElements.define('ks-lightbox', KsLightbox);
})();
